import { render, staticRenderFns } from "./UiDropdownCurrency.vue?vue&type=template&id=8970c47c&scoped=true&"
import script from "./UiDropdownCurrency.vue?vue&type=script&lang=js&"
export * from "./UiDropdownCurrency.vue?vue&type=script&lang=js&"
import style0 from "./UiDropdownCurrency.vue?vue&type=style&index=0&id=8970c47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8970c47c",
  null
  
)

export default component.exports